import type { IconsaxComponent } from "../Iconsax/Iconsax.types.js";

export enum TagV2ColorsEnum {
    primary = "primary",
    secondary = "secondary",
    tertiary = "tertiary",
    success = "success",
    error = "error",
    warning = "warning",
    blue = "blue",
    turquoise = "turquoise",
    yellow = "yellow",
    orange = "orange",
    salmon = "salmon",
    coral = "coral",
    pink = "pink",
    black = "black",
    gray = "gray",
    gradient = "gradient",
    gradiantBlackThirstday = "gradient-black-thirstday",
}

export type TagV2Colors = keyof typeof TagV2ColorsEnum;

/**
 * TagProps are the props used by the Tag component.
 */
export type TagV2Props = {
    /**
     * Icon to be placed on the right of the tag.
     */
    iconRight?: IconsaxComponent;

    /**
     * Color of the tag. It can be one of various pre-defined colors.
     * @default random
     */
    color?: TagV2Colors;

    /**
     * Function to be called when the icon is clicked.
     */
    onIconClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;

    /**
     * If true, the icon will be shown only when the tag is hovered.
     */
    displayIconOnHover?: boolean;

    /**
     * If true, the text tooltip will not be shown.
     */
    disableTooltip?: true;

    showIcon?: boolean;

    /**
     * Custom max width of the tag.
     */
    maxWidth?: string;
} & React.HTMLAttributes<HTMLSpanElement>;
